export default __webpack_public_path__ + "a154345627d508b896ad0759455719e3.png";